/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { Authentication } from 'Authentication/Authentication';
import CurrentUserInformation from 'Authentication/CurrentUserInformation';
import { getSessionId } from 'requests/sessionId';
import { v4 as uuidv4 } from 'uuid';
import * as moment from 'moment';

export class BaseClient {
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    options.headers = new Headers({
      'Content-Type': 'application/json;',
      Accept: 'application/json',
      Authorization: `Bearer ${await Authentication.Instance.GetToken()}`,
      'sekoia.session_id': getSessionId(),
      'sekoia.correlation_id': uuidv4(),
      'sekoia.customer_id': CurrentUserInformation.Instance.getUserInformation().customerId,
    });

    return options;
  }

  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REACT_APP_TASKS_BASE_URL) {
      throw new Error('REACT_APP_TASKS_BASE_URL must be set in environment');
    }

    return process.env.REACT_APP_TASKS_BASE_URL;
  }
}

export class TaskInstanceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getTaskInstances(request: GetTaskInstancesRequest): Promise<TaskInstanceResponse[]> {
        let url_ = this.baseUrl + "/api/taskinstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstances(_response);
        });
    }

    protected processGetTaskInstances(response: Response): Promise<TaskInstanceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInstanceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstanceResponse[]>(<any>null);
    }

    getTaskInstance(residentId: string | null, taskInstanceId: string | null, includeStandardTaskInformation: boolean | undefined, includeEventsAndAdditionalDetails: boolean | undefined): Promise<TaskInstanceResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/taskinstance/{taskInstanceId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (taskInstanceId === undefined || taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' must be defined.");
        url_ = url_.replace("{taskInstanceId}", encodeURIComponent("" + taskInstanceId));
        if (includeStandardTaskInformation === null)
            throw new Error("The parameter 'includeStandardTaskInformation' cannot be null.");
        else if (includeStandardTaskInformation !== undefined)
            url_ += "includeStandardTaskInformation=" + encodeURIComponent("" + includeStandardTaskInformation) + "&";
        if (includeEventsAndAdditionalDetails === null)
            throw new Error("The parameter 'includeEventsAndAdditionalDetails' cannot be null.");
        else if (includeEventsAndAdditionalDetails !== undefined)
            url_ += "includeEventsAndAdditionalDetails=" + encodeURIComponent("" + includeEventsAndAdditionalDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstance(_response);
        });
    }

    protected processGetTaskInstance(response: Response): Promise<TaskInstanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskInstanceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstanceResponse>(<any>null);
    }
}

export class TaskReportMetricClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    queryDepartmentMetricsForOrganisations(request: TaskReportMetricQueryRequest): Promise<ReportMetricResponse[]> {
        let url_ = this.baseUrl + "/api/tasks/report/metrics/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryDepartmentMetricsForOrganisations(_response);
        });
    }

    protected processQueryDepartmentMetricsForOrganisations(response: Response): Promise<ReportMetricResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportMetricResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricResponse[]>(<any>null);
    }
}

export class TaskImagesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getTaskImageUri(residentId: string | null, assignmentId: string | null, size: TaskImageSize | undefined): Promise<TaskImageResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskImageUri(_response);
        });
    }

    protected processGetTaskImageUri(response: Response): Promise<TaskImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskImageResponse>(<any>null);
    }

    uploadTaskImage(residentId: string | null, assignmentId: string | null, file: FileParameter | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadTaskImage(_response);
        });
    }

    protected processUploadTaskImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteTaskImage(residentId: string | null, assignmentId: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTaskImage(_response);
        });
    }

    protected processDeleteTaskImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class StandardTasksClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getByCustomerId(customerId: string | null, includeDeleted: boolean | undefined, trackTraceIds: string[] | null | undefined): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/standardTasks?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (trackTraceIds !== undefined && trackTraceIds !== null)
            trackTraceIds && trackTraceIds.forEach(item => { url_ += "trackTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCustomerId(_response);
        });
    }

    protected processGetByCustomerId(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    getByOrganisation(organisationId: string, includeDeleted: boolean | undefined, associatedWithPlanId: string | null | undefined, associatedWithNexusVumSubGoalId: string | null | undefined, onlyAdHoc: boolean | undefined, trackAndTraceIds: string[] | null | undefined, associatedWithId: string | null | undefined): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardtasks?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (associatedWithPlanId !== undefined && associatedWithPlanId !== null)
            url_ += "associatedWithPlanId=" + encodeURIComponent("" + associatedWithPlanId) + "&";
        if (associatedWithNexusVumSubGoalId !== undefined && associatedWithNexusVumSubGoalId !== null)
            url_ += "associatedWithNexusVumSubGoalId=" + encodeURIComponent("" + associatedWithNexusVumSubGoalId) + "&";
        if (onlyAdHoc === null)
            throw new Error("The parameter 'onlyAdHoc' cannot be null.");
        else if (onlyAdHoc !== undefined)
            url_ += "onlyAdHoc=" + encodeURIComponent("" + onlyAdHoc) + "&";
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        if (associatedWithId !== undefined && associatedWithId !== null)
            url_ += "associatedWithId=" + encodeURIComponent("" + associatedWithId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOrganisation(_response);
        });
    }

    protected processGetByOrganisation(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    createStandardTask(organisationId: string | null, request: CreateStandardTaskRequest): Promise<CreateStandardTaskResponse> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardtasks";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateStandardTask(_response);
        });
    }

    protected processCreateStandardTask(response: Response): Promise<CreateStandardTaskResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateStandardTaskResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateStandardTaskResponse>(<any>null);
    }

    getStandardTaskById(standardTaskId: string | null, trackAndTraceIds: string[] | null | undefined): Promise<StandardTaskRestEntity> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}?";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTaskById(_response);
        });
    }

    protected processGetStandardTaskById(response: Response): Promise<StandardTaskRestEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandardTaskRestEntity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity>(<any>null);
    }

    updateStandardTask(organisationId: string | null, standardTaskId: string | null, request: UpdateStandardTaskRequest): Promise<MinimalPackageInfo> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/{standardTaskId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStandardTask(_response);
        });
    }

    protected processUpdateStandardTask(response: Response): Promise<MinimalPackageInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalPackageInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalPackageInfo>(<any>null);
    }

    deleteStandardTask(organisationId: string | null, standardTaskId: string | null, request: DeleteStandardTaskRequest): Promise<MinimalPackageInfo> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/{standardTaskId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteStandardTask(_response);
        });
    }

    protected processDeleteStandardTask(response: Response): Promise<MinimalPackageInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalPackageInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalPackageInfo>(<any>null);
    }

    getStandardTasksAssociatedWithIdsBatch(organisationId: string | null, request: GetStandardTasksAssociatedWithIdsBatchRequest, trackAndTraceIds: string[] | null | undefined): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associatedWithIds?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithIdsBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithIdsBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }
}

export class StandardTasksHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getStandardTasksHistory(request: QueryStandardTasksHistoryRequest): Promise<StandardTasksHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/standardtasks/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksHistory(_response);
        });
    }

    protected processGetStandardTasksHistory(response: Response): Promise<StandardTasksHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTasksHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTasksHistoryResponse[]>(<any>null);
    }
}

export class AssociationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    updateNexusVumSubGoalAssociations(concatenatedSubGoalId: string | null, associationsRequest: UpdateNexusVumSubGoalAssociationsRequest): Promise<NexusVumSubGoalAssociationsUpdatedResponse> {
        let url_ = this.baseUrl + "/api/standardTasks/associations/nexusVumSubGoals/{concatenatedSubGoalId}";
        if (concatenatedSubGoalId === undefined || concatenatedSubGoalId === null)
            throw new Error("The parameter 'concatenatedSubGoalId' must be defined.");
        url_ = url_.replace("{concatenatedSubGoalId}", encodeURIComponent("" + concatenatedSubGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(associationsRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNexusVumSubGoalAssociations(_response);
        });
    }

    protected processUpdateNexusVumSubGoalAssociations(response: Response): Promise<NexusVumSubGoalAssociationsUpdatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NexusVumSubGoalAssociationsUpdatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NexusVumSubGoalAssociationsUpdatedResponse>(<any>null);
    }

    updatePlanAssociations(organisationId: string | null, planId: string | null, request: UpdatePlanAssociationsRequest): Promise<CreateAndDeleteAssociationBatchResponse> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/plans/{planId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePlanAssociations(_response);
        });
    }

    protected processUpdatePlanAssociations(response: Response): Promise<CreateAndDeleteAssociationBatchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAndDeleteAssociationBatchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAndDeleteAssociationBatchResponse>(<any>null);
    }

    getStandardTasksAssociatedWithPlansBatch(organisationId: string | null, request: GetStandardTasksAssociatedWithPlanIdsBatchRequest, trackAndTraceIds: string[] | null | undefined): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/plans?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithPlansBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithPlansBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    getStandardTasksAssociatedWithNexusVumSubGoalsBatch(organisationId: string | null, request: GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest, trackAndTraceIds: string[] | null | undefined): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/nexusVumSubGoals?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithNexusVumSubGoalsBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithNexusVumSubGoalsBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    updateAssociatedForms(standardTaskId: string | null, request: UpdateAssociatedFormsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssociatedForms(_response);
        });
    }

    protected processUpdateAssociatedForms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssociatedForms(standardTaskId: string | null): Promise<StandardTaskAssociatedFormResponse[]> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssociatedForms(_response);
        });
    }

    protected processGetAssociatedForms(response: Response): Promise<StandardTaskAssociatedFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskAssociatedFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskAssociatedFormResponse[]>(<any>null);
    }

    getFormsAssociatedWithTaskInstance(standardTaskId: string | null, taskInstanceId: string | null): Promise<StandardTaskAssociatedFormResponse[]> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms/taskInstance/{taskInstanceId}";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        if (taskInstanceId === undefined || taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' must be defined.");
        url_ = url_.replace("{taskInstanceId}", encodeURIComponent("" + taskInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsAssociatedWithTaskInstance(_response);
        });
    }

    protected processGetFormsAssociatedWithTaskInstance(response: Response): Promise<StandardTaskAssociatedFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskAssociatedFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskAssociatedFormResponse[]>(<any>null);
    }
}

export class AssignmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getAssignmentAudits(residentId: string | null, assignmentId: string | null): Promise<AuditResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/audits";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentAudits(_response);
        });
    }

    protected processGetAssignmentAudits(response: Response): Promise<AuditResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditResponse[]>(<any>null);
    }

    addAssignmentInstructions(residentId: string | null, assignmentId: string | null, request: AddAssignmentInstructionsRequest): Promise<CreatedAssignmentInstructionsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssignmentInstructions(_response);
        });
    }

    protected processAddAssignmentInstructions(response: Response): Promise<CreatedAssignmentInstructionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedAssignmentInstructionsResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedAssignmentInstructionsResponse>(<any>null);
    }

    getAssignmentInstructions(residentId: string | null, assignmentId: string | null): Promise<AssignmentInstructionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentInstructions(_response);
        });
    }

    protected processGetAssignmentInstructions(response: Response): Promise<AssignmentInstructionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentInstructionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInstructionResponse[]>(<any>null);
    }

    addAssignmentForms(residentId: string | null, assignmentId: string | null, request: AddAssignmentFormsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssignmentForms(_response);
        });
    }

    protected processAddAssignmentForms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssignmentForms(residentId: string | null, assignmentId: string | null): Promise<AssignmentFormResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentForms(_response);
        });
    }

    protected processGetAssignmentForms(response: Response): Promise<AssignmentFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentFormResponse[]>(<any>null);
    }

    deleteAssignmentFormForResident(residentId: string | null, formId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/forms/{formId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignmentFormForResident(_response);
        });
    }

    protected processDeleteAssignmentFormForResident(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteAllAssignmentFormsByFormId(formId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/assignments/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAllAssignmentFormsByFormId(_response);
        });
    }

    protected processDeleteAllAssignmentFormsByFormId(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    assignmentsQuery(request: AssignmentsQueryRequest): Promise<AssignmentsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/assignments/assignmentsQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignmentsQuery(_response);
        });
    }

    protected processAssignmentsQuery(response: Response): Promise<AssignmentsQueryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentsQueryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentsQueryResponse[]>(<any>null);
    }
}

export class TaskInstanceResponse implements ITaskInstanceResponse {
    id!: string;
    customerId!: string;
    standardTaskId!: string;
    taskEntryId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    title!: string;
    residentId!: string;
    taskOrganisationId!: string;
    taskState!: TaskState;
    isResidentTask!: boolean;
    isMedicationRelated!: boolean;
    isContactRelated!: boolean;
    isTwoPersonTask!: boolean;
    isHealthAct!: boolean;
    isCreatedAdHoc!: boolean;
    eventTimestamp?: moment.Moment | null;
    eventEmployeeId?: string | null;
    professionId!: string;
    delegatedProfessionId!: string;
    taskCompletionOffsetInMinutes?: number | null;
    expectedDurationInMinutes!: number;
    description?: string | null;
    assignedAtTimestamp?: moment.Moment | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeProfessionId?: number | null;
    lastUpdatedAtTimestamp?: moment.Moment | null;
    standardTaskInformation?: TaskInstanceStandardTaskInformationResponse | null;
    events!: TaskEventResponse[];
    moved!: boolean;
    movedHere!: boolean;
    originalTaskAssignmentId?: string | null;

    constructor(data?: ITaskInstanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.taskEntryId = _data["taskEntryId"] !== undefined ? _data["taskEntryId"] : <any>null;
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>null;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.taskOrganisationId = _data["taskOrganisationId"] !== undefined ? _data["taskOrganisationId"] : <any>null;
            this.taskState = _data["taskState"] !== undefined ? _data["taskState"] : <any>null;
            this.isResidentTask = _data["isResidentTask"] !== undefined ? _data["isResidentTask"] : <any>null;
            this.isMedicationRelated = _data["isMedicationRelated"] !== undefined ? _data["isMedicationRelated"] : <any>null;
            this.isContactRelated = _data["isContactRelated"] !== undefined ? _data["isContactRelated"] : <any>null;
            this.isTwoPersonTask = _data["isTwoPersonTask"] !== undefined ? _data["isTwoPersonTask"] : <any>null;
            this.isHealthAct = _data["isHealthAct"] !== undefined ? _data["isHealthAct"] : <any>null;
            this.isCreatedAdHoc = _data["isCreatedAdHoc"] !== undefined ? _data["isCreatedAdHoc"] : <any>null;
            this.eventTimestamp = _data["eventTimestamp"] ? moment(_data["eventTimestamp"].toString()) : <any>null;
            this.eventEmployeeId = _data["eventEmployeeId"] !== undefined ? _data["eventEmployeeId"] : <any>null;
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            this.taskCompletionOffsetInMinutes = _data["taskCompletionOffsetInMinutes"] !== undefined ? _data["taskCompletionOffsetInMinutes"] : <any>null;
            this.expectedDurationInMinutes = _data["expectedDurationInMinutes"] !== undefined ? _data["expectedDurationInMinutes"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.assignedAtTimestamp = _data["assignedAtTimestamp"] ? moment(_data["assignedAtTimestamp"].toString()) : <any>null;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"] !== undefined ? _data["assignedByEmployeeId"] : <any>null;
            this.assignedByEmployeeProfessionId = _data["assignedByEmployeeProfessionId"] !== undefined ? _data["assignedByEmployeeProfessionId"] : <any>null;
            this.lastUpdatedAtTimestamp = _data["lastUpdatedAtTimestamp"] ? moment(_data["lastUpdatedAtTimestamp"].toString()) : <any>null;
            this.standardTaskInformation = _data["standardTaskInformation"] ? TaskInstanceStandardTaskInformationResponse.fromJS(_data["standardTaskInformation"]) : <any>null;
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TaskEventResponse.fromJS(item));
            }
            else {
                this.events = <any>null;
            }
            this.moved = _data["moved"] !== undefined ? _data["moved"] : <any>null;
            this.movedHere = _data["movedHere"] !== undefined ? _data["movedHere"] : <any>null;
            this.originalTaskAssignmentId = _data["originalTaskAssignmentId"] !== undefined ? _data["originalTaskAssignmentId"] : <any>null;
        }
    }

    static fromJS(data: any): TaskInstanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["taskEntryId"] = this.taskEntryId !== undefined ? this.taskEntryId : <any>null;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>null;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["taskOrganisationId"] = this.taskOrganisationId !== undefined ? this.taskOrganisationId : <any>null;
        data["taskState"] = this.taskState !== undefined ? this.taskState : <any>null;
        data["isResidentTask"] = this.isResidentTask !== undefined ? this.isResidentTask : <any>null;
        data["isMedicationRelated"] = this.isMedicationRelated !== undefined ? this.isMedicationRelated : <any>null;
        data["isContactRelated"] = this.isContactRelated !== undefined ? this.isContactRelated : <any>null;
        data["isTwoPersonTask"] = this.isTwoPersonTask !== undefined ? this.isTwoPersonTask : <any>null;
        data["isHealthAct"] = this.isHealthAct !== undefined ? this.isHealthAct : <any>null;
        data["isCreatedAdHoc"] = this.isCreatedAdHoc !== undefined ? this.isCreatedAdHoc : <any>null;
        data["eventTimestamp"] = this.eventTimestamp ? this.eventTimestamp.toISOString() : <any>null;
        data["eventEmployeeId"] = this.eventEmployeeId !== undefined ? this.eventEmployeeId : <any>null;
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        data["taskCompletionOffsetInMinutes"] = this.taskCompletionOffsetInMinutes !== undefined ? this.taskCompletionOffsetInMinutes : <any>null;
        data["expectedDurationInMinutes"] = this.expectedDurationInMinutes !== undefined ? this.expectedDurationInMinutes : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["assignedAtTimestamp"] = this.assignedAtTimestamp ? this.assignedAtTimestamp.toISOString() : <any>null;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId !== undefined ? this.assignedByEmployeeId : <any>null;
        data["assignedByEmployeeProfessionId"] = this.assignedByEmployeeProfessionId !== undefined ? this.assignedByEmployeeProfessionId : <any>null;
        data["lastUpdatedAtTimestamp"] = this.lastUpdatedAtTimestamp ? this.lastUpdatedAtTimestamp.toISOString() : <any>null;
        data["standardTaskInformation"] = this.standardTaskInformation ? this.standardTaskInformation.toJSON() : <any>null;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["moved"] = this.moved !== undefined ? this.moved : <any>null;
        data["movedHere"] = this.movedHere !== undefined ? this.movedHere : <any>null;
        data["originalTaskAssignmentId"] = this.originalTaskAssignmentId !== undefined ? this.originalTaskAssignmentId : <any>null;
        return data; 
    }
}

export interface ITaskInstanceResponse {
    id: string;
    customerId: string;
    standardTaskId: string;
    taskEntryId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    title: string;
    residentId: string;
    taskOrganisationId: string;
    taskState: TaskState;
    isResidentTask: boolean;
    isMedicationRelated: boolean;
    isContactRelated: boolean;
    isTwoPersonTask: boolean;
    isHealthAct: boolean;
    isCreatedAdHoc: boolean;
    eventTimestamp?: moment.Moment | null;
    eventEmployeeId?: string | null;
    professionId: string;
    delegatedProfessionId: string;
    taskCompletionOffsetInMinutes?: number | null;
    expectedDurationInMinutes: number;
    description?: string | null;
    assignedAtTimestamp?: moment.Moment | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeProfessionId?: number | null;
    lastUpdatedAtTimestamp?: moment.Moment | null;
    standardTaskInformation?: TaskInstanceStandardTaskInformationResponse | null;
    events: TaskEventResponse[];
    moved: boolean;
    movedHere: boolean;
    originalTaskAssignmentId?: string | null;
}

export enum TaskState {
    Ready = "Ready",
    Completed = "Completed",
    Moved = "Moved",
    Cancelled = "Cancelled",
}

export class TaskInstanceStandardTaskInformationResponse implements ITaskInstanceStandardTaskInformationResponse {
    associatedNexusVumSubGoalIds!: string[];
    associatedPlanIds!: string[];
    categoryIds!: string[];
    delegationTagIds!: string[];
    canCancel!: boolean;
    canMove!: boolean;

    constructor(data?: ITaskInstanceStandardTaskInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedNexusVumSubGoalIds = [];
            this.associatedPlanIds = [];
            this.categoryIds = [];
            this.delegationTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            else {
                this.associatedNexusVumSubGoalIds = <any>null;
            }
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            else {
                this.associatedPlanIds = <any>null;
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            else {
                this.categoryIds = <any>null;
            }
            if (Array.isArray(_data["delegationTagIds"])) {
                this.delegationTagIds = [] as any;
                for (let item of _data["delegationTagIds"])
                    this.delegationTagIds!.push(item);
            }
            else {
                this.delegationTagIds = <any>null;
            }
            this.canCancel = _data["canCancel"] !== undefined ? _data["canCancel"] : <any>null;
            this.canMove = _data["canMove"] !== undefined ? _data["canMove"] : <any>null;
        }
    }

    static fromJS(data: any): TaskInstanceStandardTaskInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceStandardTaskInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.delegationTagIds)) {
            data["delegationTagIds"] = [];
            for (let item of this.delegationTagIds)
                data["delegationTagIds"].push(item);
        }
        data["canCancel"] = this.canCancel !== undefined ? this.canCancel : <any>null;
        data["canMove"] = this.canMove !== undefined ? this.canMove : <any>null;
        return data; 
    }
}

export interface ITaskInstanceStandardTaskInformationResponse {
    associatedNexusVumSubGoalIds: string[];
    associatedPlanIds: string[];
    categoryIds: string[];
    delegationTagIds: string[];
    canCancel: boolean;
    canMove: boolean;
}

export class TaskEventResponse implements ITaskEventResponse {
    employeeId!: string;
    employeeProfessionId!: number;
    timestamp!: moment.Moment;
    kind!: TaskEventType;
    assistantId?: string | null;
    assistantProfessionId?: number | null;
    movedFrom?: moment.Moment | null;
    movedTo?: moment.Moment | null;
    reason?: string | null;

    constructor(data?: ITaskEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employeeProfessionId = _data["employeeProfessionId"] !== undefined ? _data["employeeProfessionId"] : <any>null;
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.assistantId = _data["assistantId"] !== undefined ? _data["assistantId"] : <any>null;
            this.assistantProfessionId = _data["assistantProfessionId"] !== undefined ? _data["assistantProfessionId"] : <any>null;
            this.movedFrom = _data["movedFrom"] ? moment(_data["movedFrom"].toString()) : <any>null;
            this.movedTo = _data["movedTo"] ? moment(_data["movedTo"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): TaskEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employeeProfessionId"] = this.employeeProfessionId !== undefined ? this.employeeProfessionId : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["assistantId"] = this.assistantId !== undefined ? this.assistantId : <any>null;
        data["assistantProfessionId"] = this.assistantProfessionId !== undefined ? this.assistantProfessionId : <any>null;
        data["movedFrom"] = this.movedFrom ? this.movedFrom.format('YYYY-MM-DD') : <any>null;
        data["movedTo"] = this.movedTo ? this.movedTo.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data; 
    }
}

export interface ITaskEventResponse {
    employeeId: string;
    employeeProfessionId: number;
    timestamp: moment.Moment;
    kind: TaskEventType;
    assistantId?: string | null;
    assistantProfessionId?: number | null;
    movedFrom?: moment.Moment | null;
    movedTo?: moment.Moment | null;
    reason?: string | null;
}

export enum TaskEventType {
    Unknown = "Unknown",
    Completed = "Completed",
    Cancelled = "Cancelled",
    MovedAway = "MovedAway",
    MovedHere = "MovedHere",
    CompletionUndone = "CompletionUndone",
    CancellationUndone = "CancellationUndone",
}

export class GetTaskInstancesRequest implements IGetTaskInstancesRequest {
    from!: moment.Moment;
    to!: moment.Moment;
    locationIds!: string[];
    residentIds!: string[];
    includeStandardTaskInformation!: boolean;
    includeEventsAndAdditionalDetails!: boolean;

    constructor(data?: IGetTaskInstancesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locationIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>null;
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            else {
                this.locationIds = <any>null;
            }
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
            this.includeStandardTaskInformation = _data["includeStandardTaskInformation"] !== undefined ? _data["includeStandardTaskInformation"] : <any>null;
            this.includeEventsAndAdditionalDetails = _data["includeEventsAndAdditionalDetails"] !== undefined ? _data["includeEventsAndAdditionalDetails"] : <any>null;
        }
    }

    static fromJS(data: any): GetTaskInstancesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInstancesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>null;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>null;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["includeStandardTaskInformation"] = this.includeStandardTaskInformation !== undefined ? this.includeStandardTaskInformation : <any>null;
        data["includeEventsAndAdditionalDetails"] = this.includeEventsAndAdditionalDetails !== undefined ? this.includeEventsAndAdditionalDetails : <any>null;
        return data; 
    }
}

export interface IGetTaskInstancesRequest {
    from: moment.Moment;
    to: moment.Moment;
    locationIds: string[];
    residentIds: string[];
    includeStandardTaskInformation: boolean;
    includeEventsAndAdditionalDetails: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };
}

export class ReportMetricResponse implements IReportMetricResponse {

    protected _discriminator: string;

    constructor(data?: IReportMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ReportMetricResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "TaskStatusReportMetricResponse") {
            let result = new TaskStatusReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskCompletionReportMetricResponse") {
            let result = new TaskCompletionReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskProfessionsReportMetricResponse") {
            let result = new TaskProfessionsReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskDepartmentLoadReportMetricResponse") {
            let result = new TaskDepartmentLoadReportMetricResponse();
            result.init(data);
            return result;
        }
        let result = new ReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IReportMetricResponse {
}

export class TaskStatusReportMetricResponse extends ReportMetricResponse implements ITaskStatusReportMetricResponse {
    taskStatusMetricsForOrganisations!: TaskStatusForOrganisationResponse[];

    constructor(data?: ITaskStatusReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskStatusMetricsForOrganisations = [];
        }
        this._discriminator = "TaskStatusReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskStatusMetricsForOrganisations"])) {
                this.taskStatusMetricsForOrganisations = [] as any;
                for (let item of _data["taskStatusMetricsForOrganisations"])
                    this.taskStatusMetricsForOrganisations!.push(TaskStatusForOrganisationResponse.fromJS(item));
            }
            else {
                this.taskStatusMetricsForOrganisations = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskStatusReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskStatusMetricsForOrganisations)) {
            data["taskStatusMetricsForOrganisations"] = [];
            for (let item of this.taskStatusMetricsForOrganisations)
                data["taskStatusMetricsForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskStatusReportMetricResponse extends IReportMetricResponse {
    taskStatusMetricsForOrganisations: TaskStatusForOrganisationResponse[];
}

export class TaskStatusForOrganisationResponse implements ITaskStatusForOrganisationResponse {
    organisationId!: string;
    date!: moment.Moment;
    taskStatusMetricsForDepartments!: TasksStatusForDepartmentResponse[];

    constructor(data?: ITaskStatusForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskStatusMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            if (Array.isArray(_data["taskStatusMetricsForDepartments"])) {
                this.taskStatusMetricsForDepartments = [] as any;
                for (let item of _data["taskStatusMetricsForDepartments"])
                    this.taskStatusMetricsForDepartments!.push(TasksStatusForDepartmentResponse.fromJS(item));
            }
            else {
                this.taskStatusMetricsForDepartments = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskStatusForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : <any>null;
        if (Array.isArray(this.taskStatusMetricsForDepartments)) {
            data["taskStatusMetricsForDepartments"] = [];
            for (let item of this.taskStatusMetricsForDepartments)
                data["taskStatusMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskStatusForOrganisationResponse {
    organisationId: string;
    date: moment.Moment;
    taskStatusMetricsForDepartments: TasksStatusForDepartmentResponse[];
}

export class TasksStatusForDepartmentResponse implements ITasksStatusForDepartmentResponse {
    departmentId!: string;
    completed!: number;
    cancelled!: number;
    moved!: number;
    unhandled!: number;

    constructor(data?: ITasksStatusForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : <any>null;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : <any>null;
            this.cancelled = _data["cancelled"] !== undefined ? _data["cancelled"] : <any>null;
            this.moved = _data["moved"] !== undefined ? _data["moved"] : <any>null;
            this.unhandled = _data["unhandled"] !== undefined ? _data["unhandled"] : <any>null;
        }
    }

    static fromJS(data: any): TasksStatusForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TasksStatusForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : <any>null;
        data["completed"] = this.completed !== undefined ? this.completed : <any>null;
        data["cancelled"] = this.cancelled !== undefined ? this.cancelled : <any>null;
        data["moved"] = this.moved !== undefined ? this.moved : <any>null;
        data["unhandled"] = this.unhandled !== undefined ? this.unhandled : <any>null;
        return data; 
    }
}

export interface ITasksStatusForDepartmentResponse {
    departmentId: string;
    completed: number;
    cancelled: number;
    moved: number;
    unhandled: number;
}

export class TaskCompletionReportMetricResponse extends ReportMetricResponse implements ITaskCompletionReportMetricResponse {
    taskCompletionMetricsForOrganisations!: TaskCompletionForOrganisationResponse[];

    constructor(data?: ITaskCompletionReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskCompletionMetricsForOrganisations = [];
        }
        this._discriminator = "TaskCompletionReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskCompletionMetricsForOrganisations"])) {
                this.taskCompletionMetricsForOrganisations = [] as any;
                for (let item of _data["taskCompletionMetricsForOrganisations"])
                    this.taskCompletionMetricsForOrganisations!.push(TaskCompletionForOrganisationResponse.fromJS(item));
            }
            else {
                this.taskCompletionMetricsForOrganisations = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskCompletionReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskCompletionMetricsForOrganisations)) {
            data["taskCompletionMetricsForOrganisations"] = [];
            for (let item of this.taskCompletionMetricsForOrganisations)
                data["taskCompletionMetricsForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskCompletionReportMetricResponse extends IReportMetricResponse {
    taskCompletionMetricsForOrganisations: TaskCompletionForOrganisationResponse[];
}

export class TaskCompletionForOrganisationResponse implements ITaskCompletionForOrganisationResponse {
    organisationId!: string;
    taskCompletionMetricsForDepartments!: TaskCompletionForDepartmentResponse[];

    constructor(data?: ITaskCompletionForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskCompletionMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            if (Array.isArray(_data["taskCompletionMetricsForDepartments"])) {
                this.taskCompletionMetricsForDepartments = [] as any;
                for (let item of _data["taskCompletionMetricsForDepartments"])
                    this.taskCompletionMetricsForDepartments!.push(TaskCompletionForDepartmentResponse.fromJS(item));
            }
            else {
                this.taskCompletionMetricsForDepartments = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskCompletionForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        if (Array.isArray(this.taskCompletionMetricsForDepartments)) {
            data["taskCompletionMetricsForDepartments"] = [];
            for (let item of this.taskCompletionMetricsForDepartments)
                data["taskCompletionMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskCompletionForOrganisationResponse {
    organisationId: string;
    taskCompletionMetricsForDepartments: TaskCompletionForDepartmentResponse[];
}

export class TaskCompletionForDepartmentResponse implements ITaskCompletionForDepartmentResponse {
    departmentId!: string;
    taskCompletionMetricsOffsetCounts!: TaskCompletionMetricResponse[];

    constructor(data?: ITaskCompletionForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskCompletionMetricsOffsetCounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : <any>null;
            if (Array.isArray(_data["taskCompletionMetricsOffsetCounts"])) {
                this.taskCompletionMetricsOffsetCounts = [] as any;
                for (let item of _data["taskCompletionMetricsOffsetCounts"])
                    this.taskCompletionMetricsOffsetCounts!.push(TaskCompletionMetricResponse.fromJS(item));
            }
            else {
                this.taskCompletionMetricsOffsetCounts = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskCompletionForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : <any>null;
        if (Array.isArray(this.taskCompletionMetricsOffsetCounts)) {
            data["taskCompletionMetricsOffsetCounts"] = [];
            for (let item of this.taskCompletionMetricsOffsetCounts)
                data["taskCompletionMetricsOffsetCounts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskCompletionForDepartmentResponse {
    departmentId: string;
    taskCompletionMetricsOffsetCounts: TaskCompletionMetricResponse[];
}

export class TaskCompletionMetricResponse implements ITaskCompletionMetricResponse {
    taskCompletionOffsetInMinutes!: number;
    count!: number;

    constructor(data?: ITaskCompletionMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskCompletionOffsetInMinutes = _data["taskCompletionOffsetInMinutes"] !== undefined ? _data["taskCompletionOffsetInMinutes"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): TaskCompletionMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCompletionOffsetInMinutes"] = this.taskCompletionOffsetInMinutes !== undefined ? this.taskCompletionOffsetInMinutes : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data; 
    }
}

export interface ITaskCompletionMetricResponse {
    taskCompletionOffsetInMinutes: number;
    count: number;
}

export class TaskProfessionsReportMetricResponse extends ReportMetricResponse implements ITaskProfessionsReportMetricResponse {
    taskProfessionsMetricForOrganisations!: TaskProfessionsMetricForOrganisationResponse[];

    constructor(data?: ITaskProfessionsReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskProfessionsMetricForOrganisations = [];
        }
        this._discriminator = "TaskProfessionsReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskProfessionsMetricForOrganisations"])) {
                this.taskProfessionsMetricForOrganisations = [] as any;
                for (let item of _data["taskProfessionsMetricForOrganisations"])
                    this.taskProfessionsMetricForOrganisations!.push(TaskProfessionsMetricForOrganisationResponse.fromJS(item));
            }
            else {
                this.taskProfessionsMetricForOrganisations = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskProfessionsReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskProfessionsMetricForOrganisations)) {
            data["taskProfessionsMetricForOrganisations"] = [];
            for (let item of this.taskProfessionsMetricForOrganisations)
                data["taskProfessionsMetricForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskProfessionsReportMetricResponse extends IReportMetricResponse {
    taskProfessionsMetricForOrganisations: TaskProfessionsMetricForOrganisationResponse[];
}

export class TaskProfessionsMetricForOrganisationResponse implements ITaskProfessionsMetricForOrganisationResponse {
    organisationId!: string;
    taskProfessionsMetricsForDepartments!: TaskProfessionsMetricForDepartmentResponse[];

    constructor(data?: ITaskProfessionsMetricForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionsMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            if (Array.isArray(_data["taskProfessionsMetricsForDepartments"])) {
                this.taskProfessionsMetricsForDepartments = [] as any;
                for (let item of _data["taskProfessionsMetricsForDepartments"])
                    this.taskProfessionsMetricsForDepartments!.push(TaskProfessionsMetricForDepartmentResponse.fromJS(item));
            }
            else {
                this.taskProfessionsMetricsForDepartments = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskProfessionsMetricForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsMetricForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        if (Array.isArray(this.taskProfessionsMetricsForDepartments)) {
            data["taskProfessionsMetricsForDepartments"] = [];
            for (let item of this.taskProfessionsMetricsForDepartments)
                data["taskProfessionsMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskProfessionsMetricForOrganisationResponse {
    organisationId: string;
    taskProfessionsMetricsForDepartments: TaskProfessionsMetricForDepartmentResponse[];
}

export class TaskProfessionsMetricForDepartmentResponse implements ITaskProfessionsMetricForDepartmentResponse {
    taskProfessionMetrics!: TaskProfessionMetricResponse[];
    departmentId!: string;

    constructor(data?: ITaskProfessionsMetricForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionMetrics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskProfessionMetrics"])) {
                this.taskProfessionMetrics = [] as any;
                for (let item of _data["taskProfessionMetrics"])
                    this.taskProfessionMetrics!.push(TaskProfessionMetricResponse.fromJS(item));
            }
            else {
                this.taskProfessionMetrics = <any>null;
            }
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : <any>null;
        }
    }

    static fromJS(data: any): TaskProfessionsMetricForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsMetricForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskProfessionMetrics)) {
            data["taskProfessionMetrics"] = [];
            for (let item of this.taskProfessionMetrics)
                data["taskProfessionMetrics"].push(item.toJSON());
        }
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : <any>null;
        return data; 
    }
}

export interface ITaskProfessionsMetricForDepartmentResponse {
    taskProfessionMetrics: TaskProfessionMetricResponse[];
    departmentId: string;
}

export class TaskProfessionMetricResponse implements ITaskProfessionMetricResponse {
    professionId!: string;
    combinedExpectedDurationInMinutes!: number;
    amountOfTasks!: number;

    constructor(data?: ITaskProfessionMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.combinedExpectedDurationInMinutes = _data["combinedExpectedDurationInMinutes"] !== undefined ? _data["combinedExpectedDurationInMinutes"] : <any>null;
            this.amountOfTasks = _data["amountOfTasks"] !== undefined ? _data["amountOfTasks"] : <any>null;
        }
    }

    static fromJS(data: any): TaskProfessionMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["combinedExpectedDurationInMinutes"] = this.combinedExpectedDurationInMinutes !== undefined ? this.combinedExpectedDurationInMinutes : <any>null;
        data["amountOfTasks"] = this.amountOfTasks !== undefined ? this.amountOfTasks : <any>null;
        return data; 
    }
}

export interface ITaskProfessionMetricResponse {
    professionId: string;
    combinedExpectedDurationInMinutes: number;
    amountOfTasks: number;
}

export class TaskDepartmentLoadReportMetricResponse extends ReportMetricResponse implements ITaskDepartmentLoadReportMetricResponse {
    taskDepartmentLoadReportMetricForOrganisations!: TaskDepartmentLoadForOrganisationResponse[];

    constructor(data?: ITaskDepartmentLoadReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskDepartmentLoadReportMetricForOrganisations = [];
        }
        this._discriminator = "TaskDepartmentLoadReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskDepartmentLoadReportMetricForOrganisations"])) {
                this.taskDepartmentLoadReportMetricForOrganisations = [] as any;
                for (let item of _data["taskDepartmentLoadReportMetricForOrganisations"])
                    this.taskDepartmentLoadReportMetricForOrganisations!.push(TaskDepartmentLoadForOrganisationResponse.fromJS(item));
            }
            else {
                this.taskDepartmentLoadReportMetricForOrganisations = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskDepartmentLoadReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskDepartmentLoadReportMetricForOrganisations)) {
            data["taskDepartmentLoadReportMetricForOrganisations"] = [];
            for (let item of this.taskDepartmentLoadReportMetricForOrganisations)
                data["taskDepartmentLoadReportMetricForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskDepartmentLoadReportMetricResponse extends IReportMetricResponse {
    taskDepartmentLoadReportMetricForOrganisations: TaskDepartmentLoadForOrganisationResponse[];
}

export class TaskDepartmentLoadForOrganisationResponse implements ITaskDepartmentLoadForOrganisationResponse {
    organisationId!: string;
    taskProfessionsMetricsForDepartments!: TaskDepartmentLoadForDepartmentResponse[];

    constructor(data?: ITaskDepartmentLoadForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionsMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            if (Array.isArray(_data["taskProfessionsMetricsForDepartments"])) {
                this.taskProfessionsMetricsForDepartments = [] as any;
                for (let item of _data["taskProfessionsMetricsForDepartments"])
                    this.taskProfessionsMetricsForDepartments!.push(TaskDepartmentLoadForDepartmentResponse.fromJS(item));
            }
            else {
                this.taskProfessionsMetricsForDepartments = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskDepartmentLoadForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        if (Array.isArray(this.taskProfessionsMetricsForDepartments)) {
            data["taskProfessionsMetricsForDepartments"] = [];
            for (let item of this.taskProfessionsMetricsForDepartments)
                data["taskProfessionsMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskDepartmentLoadForOrganisationResponse {
    organisationId: string;
    taskProfessionsMetricsForDepartments: TaskDepartmentLoadForDepartmentResponse[];
}

export class TaskDepartmentLoadForDepartmentResponse implements ITaskDepartmentLoadForDepartmentResponse {
    taskDepartmentLoadMetric!: TaskDepartmentLoadMetricResponse;
    departmentId!: string;

    constructor(data?: ITaskDepartmentLoadForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskDepartmentLoadMetric = new TaskDepartmentLoadMetricResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskDepartmentLoadMetric = _data["taskDepartmentLoadMetric"] ? TaskDepartmentLoadMetricResponse.fromJS(_data["taskDepartmentLoadMetric"]) : new TaskDepartmentLoadMetricResponse();
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : <any>null;
        }
    }

    static fromJS(data: any): TaskDepartmentLoadForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDepartmentLoadMetric"] = this.taskDepartmentLoadMetric ? this.taskDepartmentLoadMetric.toJSON() : <any>null;
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : <any>null;
        return data; 
    }
}

export interface ITaskDepartmentLoadForDepartmentResponse {
    taskDepartmentLoadMetric: TaskDepartmentLoadMetricResponse;
    departmentId: string;
}

export class TaskDepartmentLoadMetricResponse implements ITaskDepartmentLoadMetricResponse {
    departmentLoadStatus!: DepartmentLoadStatus;
    combinedTasksWorkTimeInMinutes!: number;
    amountOfTasksOverdue!: number;

    constructor(data?: ITaskDepartmentLoadMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentLoadStatus = _data["departmentLoadStatus"] !== undefined ? _data["departmentLoadStatus"] : <any>null;
            this.combinedTasksWorkTimeInMinutes = _data["combinedTasksWorkTimeInMinutes"] !== undefined ? _data["combinedTasksWorkTimeInMinutes"] : <any>null;
            this.amountOfTasksOverdue = _data["amountOfTasksOverdue"] !== undefined ? _data["amountOfTasksOverdue"] : <any>null;
        }
    }

    static fromJS(data: any): TaskDepartmentLoadMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentLoadStatus"] = this.departmentLoadStatus !== undefined ? this.departmentLoadStatus : <any>null;
        data["combinedTasksWorkTimeInMinutes"] = this.combinedTasksWorkTimeInMinutes !== undefined ? this.combinedTasksWorkTimeInMinutes : <any>null;
        data["amountOfTasksOverdue"] = this.amountOfTasksOverdue !== undefined ? this.amountOfTasksOverdue : <any>null;
        return data; 
    }
}

export interface ITaskDepartmentLoadMetricResponse {
    departmentLoadStatus: DepartmentLoadStatus;
    combinedTasksWorkTimeInMinutes: number;
    amountOfTasksOverdue: number;
}

export enum DepartmentLoadStatus {
    Normal = "Normal",
    Busy = "Busy",
    Stressed = "Stressed",
}

export class TaskReportMetricQueryRequest implements ITaskReportMetricQueryRequest {
    date!: moment.Moment;
    organisationIds!: string[];
    metricNames!: ReportMetricNames[];

    constructor(data?: ITaskReportMetricQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationIds = [];
            this.metricNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            if (Array.isArray(_data["organisationIds"])) {
                this.organisationIds = [] as any;
                for (let item of _data["organisationIds"])
                    this.organisationIds!.push(item);
            }
            else {
                this.organisationIds = <any>null;
            }
            if (Array.isArray(_data["metricNames"])) {
                this.metricNames = [] as any;
                for (let item of _data["metricNames"])
                    this.metricNames!.push(item);
            }
            else {
                this.metricNames = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskReportMetricQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskReportMetricQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : <any>null;
        if (Array.isArray(this.organisationIds)) {
            data["organisationIds"] = [];
            for (let item of this.organisationIds)
                data["organisationIds"].push(item);
        }
        if (Array.isArray(this.metricNames)) {
            data["metricNames"] = [];
            for (let item of this.metricNames)
                data["metricNames"].push(item);
        }
        return data; 
    }
}

export interface ITaskReportMetricQueryRequest {
    date: moment.Moment;
    organisationIds: string[];
    metricNames: ReportMetricNames[];
}

export enum ReportMetricNames {
    TaskStatus = "TaskStatus",
    TaskCompletion = "TaskCompletion",
    TaskProfessions = "TaskProfessions",
    TaskDepartmentLoad = "TaskDepartmentLoad",
}

export class TaskImageResponse implements ITaskImageResponse {
    uri!: string;

    constructor(data?: ITaskImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"] !== undefined ? _data["uri"] : <any>null;
        }
    }

    static fromJS(data: any): TaskImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri !== undefined ? this.uri : <any>null;
        return data; 
    }
}

export interface ITaskImageResponse {
    uri: string;
}

export enum TaskImageSize {
    Thumbnail = "Thumbnail",
    Detail = "Detail",
    Hd = "Hd",
}

export class StandardTaskRestEntity implements IStandardTaskRestEntity {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];
    description!: string;
    durationInMinutes!: number;
    id!: string;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    lamport!: number;
    owningOrganisationId!: string;
    professionId!: string;
    requiresTwoWorkers!: boolean;
    title!: string;
    associatedPlanIds!: string[];
    associatedNexusVumSubGoalIds!: string[];
    isDeleted!: boolean;
    trimmedId!: string;

    constructor(data?: IStandardTaskRestEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
            this.associatedPlanIds = [];
            this.associatedNexusVumSubGoalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"] !== undefined ? _data["canCreateAdHoc"] : <any>null;
            this.canMove = _data["canMove"] !== undefined ? _data["canMove"] : <any>null;
            this.canCancel = _data["canCancel"] !== undefined ? _data["canCancel"] : <any>null;
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            else {
                this.categoryIds = <any>null;
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.durationInMinutes = _data["durationInMinutes"] !== undefined ? _data["durationInMinutes"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isContactPersonRelated = _data["isContactPersonRelated"] !== undefined ? _data["isContactPersonRelated"] : <any>null;
            this.isMedicationRelated = _data["isMedicationRelated"] !== undefined ? _data["isMedicationRelated"] : <any>null;
            this.lamport = _data["lamport"] !== undefined ? _data["lamport"] : <any>null;
            this.owningOrganisationId = _data["owningOrganisationId"] !== undefined ? _data["owningOrganisationId"] : <any>null;
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.requiresTwoWorkers = _data["requiresTwoWorkers"] !== undefined ? _data["requiresTwoWorkers"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            else {
                this.associatedPlanIds = <any>null;
            }
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            else {
                this.associatedNexusVumSubGoalIds = <any>null;
            }
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.trimmedId = _data["trimmedId"] !== undefined ? _data["trimmedId"] : <any>null;
        }
    }

    static fromJS(data: any): StandardTaskRestEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskRestEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc !== undefined ? this.canCreateAdHoc : <any>null;
        data["canMove"] = this.canMove !== undefined ? this.canMove : <any>null;
        data["canCancel"] = this.canCancel !== undefined ? this.canCancel : <any>null;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["durationInMinutes"] = this.durationInMinutes !== undefined ? this.durationInMinutes : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isContactPersonRelated"] = this.isContactPersonRelated !== undefined ? this.isContactPersonRelated : <any>null;
        data["isMedicationRelated"] = this.isMedicationRelated !== undefined ? this.isMedicationRelated : <any>null;
        data["lamport"] = this.lamport !== undefined ? this.lamport : <any>null;
        data["owningOrganisationId"] = this.owningOrganisationId !== undefined ? this.owningOrganisationId : <any>null;
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers !== undefined ? this.requiresTwoWorkers : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["trimmedId"] = this.trimmedId !== undefined ? this.trimmedId : <any>null;
        return data; 
    }
}

export interface IStandardTaskRestEntity {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
    description: string;
    durationInMinutes: number;
    id: string;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    lamport: number;
    owningOrganisationId: string;
    professionId: string;
    requiresTwoWorkers: boolean;
    title: string;
    associatedPlanIds: string[];
    associatedNexusVumSubGoalIds: string[];
    isDeleted: boolean;
    trimmedId: string;
}

export class MinimalPackageInfo implements IMinimalPackageInfo {
    trackTraceId?: string | null;

    constructor(data?: IMinimalPackageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackTraceId = _data["trackTraceId"] !== undefined ? _data["trackTraceId"] : <any>null;
        }
    }

    static fromJS(data: any): MinimalPackageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalPackageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackTraceId"] = this.trackTraceId !== undefined ? this.trackTraceId : <any>null;
        return data; 
    }
}

export interface IMinimalPackageInfo {
    trackTraceId?: string | null;
}

export class UpdateStandardTaskRequest implements IUpdateStandardTaskRequest {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];
    description?: string | null;
    durationInMinutes!: number;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    lamport!: number;
    professionId!: number;
    requiresTwoWorkers!: boolean;
    title!: string;

    constructor(data?: IUpdateStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"] !== undefined ? _data["canCreateAdHoc"] : <any>null;
            this.canMove = _data["canMove"] !== undefined ? _data["canMove"] : <any>null;
            this.canCancel = _data["canCancel"] !== undefined ? _data["canCancel"] : <any>null;
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            else {
                this.categoryIds = <any>null;
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.durationInMinutes = _data["durationInMinutes"] !== undefined ? _data["durationInMinutes"] : <any>null;
            this.isContactPersonRelated = _data["isContactPersonRelated"] !== undefined ? _data["isContactPersonRelated"] : <any>null;
            this.isMedicationRelated = _data["isMedicationRelated"] !== undefined ? _data["isMedicationRelated"] : <any>null;
            this.lamport = _data["lamport"] !== undefined ? _data["lamport"] : <any>null;
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.requiresTwoWorkers = _data["requiresTwoWorkers"] !== undefined ? _data["requiresTwoWorkers"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc !== undefined ? this.canCreateAdHoc : <any>null;
        data["canMove"] = this.canMove !== undefined ? this.canMove : <any>null;
        data["canCancel"] = this.canCancel !== undefined ? this.canCancel : <any>null;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["durationInMinutes"] = this.durationInMinutes !== undefined ? this.durationInMinutes : <any>null;
        data["isContactPersonRelated"] = this.isContactPersonRelated !== undefined ? this.isContactPersonRelated : <any>null;
        data["isMedicationRelated"] = this.isMedicationRelated !== undefined ? this.isMedicationRelated : <any>null;
        data["lamport"] = this.lamport !== undefined ? this.lamport : <any>null;
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers !== undefined ? this.requiresTwoWorkers : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface IUpdateStandardTaskRequest {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
    description?: string | null;
    durationInMinutes: number;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    lamport: number;
    professionId: number;
    requiresTwoWorkers: boolean;
    title: string;
}

export class GetStandardTasksAssociatedWithIdsBatchRequest implements IGetStandardTasksAssociatedWithIdsBatchRequest {
    associatedWithIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedWithIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedWithIds"])) {
                this.associatedWithIds = [] as any;
                for (let item of _data["associatedWithIds"])
                    this.associatedWithIds!.push(item);
            }
            else {
                this.associatedWithIds = <any>null;
            }
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedWithIds)) {
            data["associatedWithIds"] = [];
            for (let item of this.associatedWithIds)
                data["associatedWithIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : <any>null;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithIdsBatchRequest {
    associatedWithIds: string[];
    includeDeleted: boolean;
}

export class CreateStandardTaskResponse extends MinimalPackageInfo implements ICreateStandardTaskResponse {
    standardTaskId!: string;

    constructor(data?: ICreateStandardTaskResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateStandardTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStandardTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICreateStandardTaskResponse extends IMinimalPackageInfo {
    standardTaskId: string;
}

export class CreateStandardTaskRequest implements ICreateStandardTaskRequest {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    description!: string;
    durationInMinutes!: number;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    professionId!: number;
    requiresTwoWorkers!: boolean;
    title!: string;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];

    constructor(data?: ICreateStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"] !== undefined ? _data["canCreateAdHoc"] : <any>null;
            this.canMove = _data["canMove"] !== undefined ? _data["canMove"] : <any>null;
            this.canCancel = _data["canCancel"] !== undefined ? _data["canCancel"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.durationInMinutes = _data["durationInMinutes"] !== undefined ? _data["durationInMinutes"] : <any>null;
            this.isContactPersonRelated = _data["isContactPersonRelated"] !== undefined ? _data["isContactPersonRelated"] : <any>null;
            this.isMedicationRelated = _data["isMedicationRelated"] !== undefined ? _data["isMedicationRelated"] : <any>null;
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.requiresTwoWorkers = _data["requiresTwoWorkers"] !== undefined ? _data["requiresTwoWorkers"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            else {
                this.categoryIds = <any>null;
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc !== undefined ? this.canCreateAdHoc : <any>null;
        data["canMove"] = this.canMove !== undefined ? this.canMove : <any>null;
        data["canCancel"] = this.canCancel !== undefined ? this.canCancel : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["durationInMinutes"] = this.durationInMinutes !== undefined ? this.durationInMinutes : <any>null;
        data["isContactPersonRelated"] = this.isContactPersonRelated !== undefined ? this.isContactPersonRelated : <any>null;
        data["isMedicationRelated"] = this.isMedicationRelated !== undefined ? this.isMedicationRelated : <any>null;
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers !== undefined ? this.requiresTwoWorkers : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateStandardTaskRequest {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    description: string;
    durationInMinutes: number;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    professionId: number;
    requiresTwoWorkers: boolean;
    title: string;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
}

export class DeleteStandardTaskRequest implements IDeleteStandardTaskRequest {
    lamport!: number;

    constructor(data?: IDeleteStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lamport = _data["lamport"] !== undefined ? _data["lamport"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lamport"] = this.lamport !== undefined ? this.lamport : <any>null;
        return data; 
    }
}

export interface IDeleteStandardTaskRequest {
    lamport: number;
}

export class StandardTasksHistoryResponse implements IStandardTasksHistoryResponse {
    standardTaskId!: string;
    taskVersions!: StandardTaskVersionResponse[];

    constructor(data?: IStandardTasksHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskVersions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            if (Array.isArray(_data["taskVersions"])) {
                this.taskVersions = [] as any;
                for (let item of _data["taskVersions"])
                    this.taskVersions!.push(StandardTaskVersionResponse.fromJS(item));
            }
            else {
                this.taskVersions = <any>null;
            }
        }
    }

    static fromJS(data: any): StandardTasksHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTasksHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        if (Array.isArray(this.taskVersions)) {
            data["taskVersions"] = [];
            for (let item of this.taskVersions)
                data["taskVersions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStandardTasksHistoryResponse {
    standardTaskId: string;
    taskVersions: StandardTaskVersionResponse[];
}

export class StandardTaskVersionResponse implements IStandardTaskVersionResponse {
    beginTime!: moment.Moment;
    task!: StandardTaskRestEntity;

    constructor(data?: IStandardTaskVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.task = new StandardTaskRestEntity();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : <any>null;
            this.task = _data["task"] ? StandardTaskRestEntity.fromJS(_data["task"]) : new StandardTaskRestEntity();
        }
    }

    static fromJS(data: any): StandardTaskVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : <any>null;
        data["task"] = this.task ? this.task.toJSON() : <any>null;
        return data; 
    }
}

export interface IStandardTaskVersionResponse {
    beginTime: moment.Moment;
    task: StandardTaskRestEntity;
}

export class QueryStandardTasksHistoryRequest implements IQueryStandardTasksHistoryRequest {
    standardTaskIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IQueryStandardTasksHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTaskIds"])) {
                this.standardTaskIds = [] as any;
                for (let item of _data["standardTaskIds"])
                    this.standardTaskIds!.push(item);
            }
            else {
                this.standardTaskIds = <any>null;
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): QueryStandardTasksHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QueryStandardTasksHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTaskIds)) {
            data["standardTaskIds"] = [];
            for (let item of this.standardTaskIds)
                data["standardTaskIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>null;
        data["to"] = this.to ? this.to.toISOString() : <any>null;
        return data; 
    }
}

export interface IQueryStandardTasksHistoryRequest {
    standardTaskIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class NexusVumSubGoalAssociationsUpdatedResponse implements INexusVumSubGoalAssociationsUpdatedResponse {
    standardTaskAssociatedResults!: StandardTaskAssociationUpdatedResult[];
    trackTraceIds!: string[];

    constructor(data?: INexusVumSubGoalAssociationsUpdatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTaskAssociatedResults = [];
            this.trackTraceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTaskAssociatedResults"])) {
                this.standardTaskAssociatedResults = [] as any;
                for (let item of _data["standardTaskAssociatedResults"])
                    this.standardTaskAssociatedResults!.push(StandardTaskAssociationUpdatedResult.fromJS(item));
            }
            else {
                this.standardTaskAssociatedResults = <any>null;
            }
            if (Array.isArray(_data["trackTraceIds"])) {
                this.trackTraceIds = [] as any;
                for (let item of _data["trackTraceIds"])
                    this.trackTraceIds!.push(item);
            }
            else {
                this.trackTraceIds = <any>null;
            }
        }
    }

    static fromJS(data: any): NexusVumSubGoalAssociationsUpdatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NexusVumSubGoalAssociationsUpdatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTaskAssociatedResults)) {
            data["standardTaskAssociatedResults"] = [];
            for (let item of this.standardTaskAssociatedResults)
                data["standardTaskAssociatedResults"].push(item.toJSON());
        }
        if (Array.isArray(this.trackTraceIds)) {
            data["trackTraceIds"] = [];
            for (let item of this.trackTraceIds)
                data["trackTraceIds"].push(item);
        }
        return data; 
    }
}

export interface INexusVumSubGoalAssociationsUpdatedResponse {
    standardTaskAssociatedResults: StandardTaskAssociationUpdatedResult[];
    trackTraceIds: string[];
}

export class StandardTaskAssociationUpdatedResult implements IStandardTaskAssociationUpdatedResult {
    standardTaskId!: string;
    success!: boolean;

    constructor(data?: IStandardTaskAssociationUpdatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
        }
    }

    static fromJS(data: any): StandardTaskAssociationUpdatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskAssociationUpdatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        return data; 
    }
}

export interface IStandardTaskAssociationUpdatedResult {
    standardTaskId: string;
    success: boolean;
}

export class UpdateNexusVumSubGoalAssociationsRequest implements IUpdateNexusVumSubGoalAssociationsRequest {
    standardTasksToAdd!: StandardTaskIdAndLamportTimestampRequest[];
    standardTasksToRemove!: StandardTaskIdAndLamportTimestampRequest[];

    constructor(data?: IUpdateNexusVumSubGoalAssociationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTasksToAdd = [];
            this.standardTasksToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTasksToAdd"])) {
                this.standardTasksToAdd = [] as any;
                for (let item of _data["standardTasksToAdd"])
                    this.standardTasksToAdd!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            else {
                this.standardTasksToAdd = <any>null;
            }
            if (Array.isArray(_data["standardTasksToRemove"])) {
                this.standardTasksToRemove = [] as any;
                for (let item of _data["standardTasksToRemove"])
                    this.standardTasksToRemove!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            else {
                this.standardTasksToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateNexusVumSubGoalAssociationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNexusVumSubGoalAssociationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTasksToAdd)) {
            data["standardTasksToAdd"] = [];
            for (let item of this.standardTasksToAdd)
                data["standardTasksToAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.standardTasksToRemove)) {
            data["standardTasksToRemove"] = [];
            for (let item of this.standardTasksToRemove)
                data["standardTasksToRemove"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNexusVumSubGoalAssociationsRequest {
    standardTasksToAdd: StandardTaskIdAndLamportTimestampRequest[];
    standardTasksToRemove: StandardTaskIdAndLamportTimestampRequest[];
}

export class StandardTaskIdAndLamportTimestampRequest implements IStandardTaskIdAndLamportTimestampRequest {
    standardTaskId!: string;
    lamportTimeStamp!: number;

    constructor(data?: IStandardTaskIdAndLamportTimestampRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.lamportTimeStamp = _data["lamportTimeStamp"] !== undefined ? _data["lamportTimeStamp"] : <any>null;
        }
    }

    static fromJS(data: any): StandardTaskIdAndLamportTimestampRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskIdAndLamportTimestampRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["lamportTimeStamp"] = this.lamportTimeStamp !== undefined ? this.lamportTimeStamp : <any>null;
        return data; 
    }
}

export interface IStandardTaskIdAndLamportTimestampRequest {
    standardTaskId: string;
    lamportTimeStamp: number;
}

export class CreateAndDeleteAssociationBatchResponse implements ICreateAndDeleteAssociationBatchResponse {
    resultForStandardTask!: AssociationResultResponse[];
    trackTraceId!: string[];

    constructor(data?: ICreateAndDeleteAssociationBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resultForStandardTask = [];
            this.trackTraceId = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resultForStandardTask"])) {
                this.resultForStandardTask = [] as any;
                for (let item of _data["resultForStandardTask"])
                    this.resultForStandardTask!.push(AssociationResultResponse.fromJS(item));
            }
            else {
                this.resultForStandardTask = <any>null;
            }
            if (Array.isArray(_data["trackTraceId"])) {
                this.trackTraceId = [] as any;
                for (let item of _data["trackTraceId"])
                    this.trackTraceId!.push(item);
            }
            else {
                this.trackTraceId = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateAndDeleteAssociationBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAndDeleteAssociationBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resultForStandardTask)) {
            data["resultForStandardTask"] = [];
            for (let item of this.resultForStandardTask)
                data["resultForStandardTask"].push(item.toJSON());
        }
        if (Array.isArray(this.trackTraceId)) {
            data["trackTraceId"] = [];
            for (let item of this.trackTraceId)
                data["trackTraceId"].push(item);
        }
        return data; 
    }
}

export interface ICreateAndDeleteAssociationBatchResponse {
    resultForStandardTask: AssociationResultResponse[];
    trackTraceId: string[];
}

export class AssociationResultResponse implements IAssociationResultResponse {
    standardTaskId!: string;
    success!: boolean;

    constructor(data?: IAssociationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
        }
    }

    static fromJS(data: any): AssociationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssociationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        return data; 
    }
}

export interface IAssociationResultResponse {
    standardTaskId: string;
    success: boolean;
}

export class UpdatePlanAssociationsRequest implements IUpdatePlanAssociationsRequest {
    addStandardTaskIds!: StandardTaskIdAndLamportTimestampRequest[];
    removeStandardTaskIds!: StandardTaskIdAndLamportTimestampRequest[];

    constructor(data?: IUpdatePlanAssociationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.addStandardTaskIds = [];
            this.removeStandardTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addStandardTaskIds"])) {
                this.addStandardTaskIds = [] as any;
                for (let item of _data["addStandardTaskIds"])
                    this.addStandardTaskIds!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            else {
                this.addStandardTaskIds = <any>null;
            }
            if (Array.isArray(_data["removeStandardTaskIds"])) {
                this.removeStandardTaskIds = [] as any;
                for (let item of _data["removeStandardTaskIds"])
                    this.removeStandardTaskIds!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            else {
                this.removeStandardTaskIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdatePlanAssociationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanAssociationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addStandardTaskIds)) {
            data["addStandardTaskIds"] = [];
            for (let item of this.addStandardTaskIds)
                data["addStandardTaskIds"].push(item.toJSON());
        }
        if (Array.isArray(this.removeStandardTaskIds)) {
            data["removeStandardTaskIds"] = [];
            for (let item of this.removeStandardTaskIds)
                data["removeStandardTaskIds"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePlanAssociationsRequest {
    addStandardTaskIds: StandardTaskIdAndLamportTimestampRequest[];
    removeStandardTaskIds: StandardTaskIdAndLamportTimestampRequest[];
}

export class GetStandardTasksAssociatedWithPlanIdsBatchRequest implements IGetStandardTasksAssociatedWithPlanIdsBatchRequest {
    associatedPlanIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithPlanIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedPlanIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            else {
                this.associatedPlanIds = <any>null;
            }
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithPlanIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithPlanIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : <any>null;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithPlanIdsBatchRequest {
    associatedPlanIds: string[];
    includeDeleted: boolean;
}

export class GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest implements IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
    associatedNexusVumSubGoalIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedNexusVumSubGoalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            else {
                this.associatedNexusVumSubGoalIds = <any>null;
            }
            this.includeDeleted = _data["includeDeleted"] !== undefined ? _data["includeDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted !== undefined ? this.includeDeleted : <any>null;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
    associatedNexusVumSubGoalIds: string[];
    includeDeleted: boolean;
}

export class UpdateAssociatedFormsRequest implements IUpdateAssociatedFormsRequest {
    forms!: StandardTaskFormRequest[];

    constructor(data?: IUpdateAssociatedFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(StandardTaskFormRequest.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateAssociatedFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssociatedFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAssociatedFormsRequest {
    forms: StandardTaskFormRequest[];
}

export class StandardTaskFormRequest implements IStandardTaskFormRequest {
    formId!: string;
    required!: boolean;
    order!: number;

    constructor(data?: IStandardTaskFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): StandardTaskFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data; 
    }
}

export interface IStandardTaskFormRequest {
    formId: string;
    required: boolean;
    order: number;
}

export class StandardTaskAssociatedFormResponse implements IStandardTaskAssociatedFormResponse {
    standardTaskId!: string;
    order!: number;
    formId!: string;
    required!: boolean;
    registrationId?: string | null;

    constructor(data?: IStandardTaskAssociatedFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
        }
    }

    static fromJS(data: any): StandardTaskAssociatedFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskAssociatedFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        return data; 
    }
}

export interface IStandardTaskAssociatedFormResponse {
    standardTaskId: string;
    order: number;
    formId: string;
    required: boolean;
    registrationId?: string | null;
}

export class AuditResponse implements IAuditResponse {
    valueType!: AuditType;
    executedById!: string;
    timeStamp!: moment.Moment;
    oldValue!: AuditResponseObject;
    newValue!: AuditResponseObject;

    constructor(data?: IAuditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueType = _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
            this.executedById = _data["executedById"] !== undefined ? _data["executedById"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? moment(_data["timeStamp"].toString()) : <any>null;
            this.oldValue = _data["oldValue"] ? AuditResponseObject.fromJS(_data["oldValue"]) : <any>null;
            this.newValue = _data["newValue"] ? AuditResponseObject.fromJS(_data["newValue"]) : <any>null;
        }
    }

    static fromJS(data: any): AuditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueType"] = this.valueType !== undefined ? this.valueType : <any>null;
        data["executedById"] = this.executedById !== undefined ? this.executedById : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["oldValue"] = this.oldValue ? this.oldValue.toJSON() : <any>null;
        data["newValue"] = this.newValue ? this.newValue.toJSON() : <any>null;
        return data; 
    }
}

export interface IAuditResponse {
    valueType: AuditType;
    executedById: string;
    timeStamp: moment.Moment;
    oldValue: AuditResponseObject;
    newValue: AuditResponseObject;
}

export enum AuditType {
    Unknown = "Unknown",
    Instructions = "Instructions",
    Forms = "Forms",
    Description = "Description",
    TaskType = "TaskType",
    ExecutionInterval = "ExecutionInterval",
    RecurrencePattern = "RecurrencePattern",
    Professions = "Professions",
    TaskAssignment = "TaskAssignment",
    AdditionalRepetitionIntervals = "AdditionalRepetitionIntervals",
}

export abstract class AuditResponseObject implements IAuditResponseObject {

    protected _discriminator: string;

    constructor(data?: IAuditResponseObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AuditResponseObject";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AuditResponseObject {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "AuditLogDescriptionResponse") {
            let result = new AuditLogDescriptionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogExecutionIntervalResponse") {
            let result = new AuditLogExecutionIntervalResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogFormResponse") {
            let result = new AuditLogFormResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogInstructionResponse") {
            let result = new AuditLogInstructionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogProfessionResponse") {
            let result = new AuditLogProfessionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogRecurrencePatternResponse") {
            let result = new AuditLogRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "WeeklyRepetitionPatternResponse") {
            let result = new WeeklyRepetitionPatternResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogTaskTypeResponse") {
            let result = new AuditLogTaskTypeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogTaskAssignmentResponse") {
            let result = new AuditLogTaskAssignmentResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogAdditionalRepetitionIntervalsResponse") {
            let result = new AuditLogAdditionalRepetitionIntervalsResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AuditResponseObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IAuditResponseObject {
}

export class AuditLogDescriptionResponse extends AuditResponseObject implements IAuditLogDescriptionResponse {
    description!: string;

    constructor(data?: IAuditLogDescriptionResponse) {
        super(data);
        this._discriminator = "AuditLogDescriptionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): AuditLogDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogDescriptionResponse extends IAuditResponseObject {
    description: string;
}

export class AuditLogExecutionIntervalResponse extends AuditResponseObject implements IAuditLogExecutionIntervalResponse {
    startHour!: string;
    endHour!: string;
    expectedExecutionTime!: number;

    constructor(data?: IAuditLogExecutionIntervalResponse) {
        super(data);
        this._discriminator = "AuditLogExecutionIntervalResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startHour = _data["startHour"] !== undefined ? _data["startHour"] : <any>null;
            this.endHour = _data["endHour"] !== undefined ? _data["endHour"] : <any>null;
            this.expectedExecutionTime = _data["expectedExecutionTime"] !== undefined ? _data["expectedExecutionTime"] : <any>null;
        }
    }

    static fromJS(data: any): AuditLogExecutionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExecutionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startHour"] = this.startHour !== undefined ? this.startHour : <any>null;
        data["endHour"] = this.endHour !== undefined ? this.endHour : <any>null;
        data["expectedExecutionTime"] = this.expectedExecutionTime !== undefined ? this.expectedExecutionTime : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogExecutionIntervalResponse extends IAuditResponseObject {
    startHour: string;
    endHour: string;
    expectedExecutionTime: number;
}

export class AuditLogFormResponse extends AuditResponseObject implements IAuditLogFormResponse {
    forms!: FormResponse[];

    constructor(data?: IAuditLogFormResponse) {
        super(data);
        if (!data) {
            this.forms = [];
        }
        this._discriminator = "AuditLogFormResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormResponse.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): AuditLogFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogFormResponse extends IAuditResponseObject {
    forms: FormResponse[];
}

export class FormResponse implements IFormResponse {
    id!: string;
    order!: number;
    required!: boolean;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        return data; 
    }
}

export interface IFormResponse {
    id: string;
    order: number;
    required: boolean;
}

export class AuditLogInstructionResponse extends AuditResponseObject implements IAuditLogInstructionResponse {
    instructions!: InstructionResponse[];

    constructor(data?: IAuditLogInstructionResponse) {
        super(data);
        if (!data) {
            this.instructions = [];
        }
        this._discriminator = "AuditLogInstructionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionResponse.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
        }
    }

    static fromJS(data: any): AuditLogInstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogInstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogInstructionResponse extends IAuditResponseObject {
    instructions: InstructionResponse[];
}

export class InstructionResponse implements IInstructionResponse {
    id!: string;
    order!: number;

    constructor(data?: IInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): InstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data; 
    }
}

export interface IInstructionResponse {
    id: string;
    order: number;
}

export class AuditLogProfessionResponse extends AuditResponseObject implements IAuditLogProfessionResponse {
    selectedProfessionIds!: number[];

    constructor(data?: IAuditLogProfessionResponse) {
        super(data);
        if (!data) {
            this.selectedProfessionIds = [];
        }
        this._discriminator = "AuditLogProfessionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedProfessionIds"])) {
                this.selectedProfessionIds = [] as any;
                for (let item of _data["selectedProfessionIds"])
                    this.selectedProfessionIds!.push(item);
            }
            else {
                this.selectedProfessionIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AuditLogProfessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogProfessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedProfessionIds)) {
            data["selectedProfessionIds"] = [];
            for (let item of this.selectedProfessionIds)
                data["selectedProfessionIds"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogProfessionResponse extends IAuditResponseObject {
    selectedProfessionIds: number[];
}

export class AuditLogRecurrencePatternResponse extends AuditResponseObject implements IAuditLogRecurrencePatternResponse {
    repeat!: boolean;
    repeatEndType!: string;
    repeatEndValue!: string;
    repeatType!: string;
    repeatInterval!: number;
    weeklyRepetitionPattern!: WeeklyRepetitionPatternResponse;

    constructor(data?: IAuditLogRecurrencePatternResponse) {
        super(data);
        if (!data) {
            this.weeklyRepetitionPattern = new WeeklyRepetitionPatternResponse();
        }
        this._discriminator = "AuditLogRecurrencePatternResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.repeat = _data["repeat"] !== undefined ? _data["repeat"] : <any>null;
            this.repeatEndType = _data["repeatEndType"] !== undefined ? _data["repeatEndType"] : <any>null;
            this.repeatEndValue = _data["repeatEndValue"] !== undefined ? _data["repeatEndValue"] : <any>null;
            this.repeatType = _data["repeatType"] !== undefined ? _data["repeatType"] : <any>null;
            this.repeatInterval = _data["repeatInterval"] !== undefined ? _data["repeatInterval"] : <any>null;
            this.weeklyRepetitionPattern = _data["weeklyRepetitionPattern"] ? WeeklyRepetitionPatternResponse.fromJS(_data["weeklyRepetitionPattern"]) : new WeeklyRepetitionPatternResponse();
        }
    }

    static fromJS(data: any): AuditLogRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repeat"] = this.repeat !== undefined ? this.repeat : <any>null;
        data["repeatEndType"] = this.repeatEndType !== undefined ? this.repeatEndType : <any>null;
        data["repeatEndValue"] = this.repeatEndValue !== undefined ? this.repeatEndValue : <any>null;
        data["repeatType"] = this.repeatType !== undefined ? this.repeatType : <any>null;
        data["repeatInterval"] = this.repeatInterval !== undefined ? this.repeatInterval : <any>null;
        data["weeklyRepetitionPattern"] = this.weeklyRepetitionPattern ? this.weeklyRepetitionPattern.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogRecurrencePatternResponse extends IAuditResponseObject {
    repeat: boolean;
    repeatEndType: string;
    repeatEndValue: string;
    repeatType: string;
    repeatInterval: number;
    weeklyRepetitionPattern: WeeklyRepetitionPatternResponse;
}

export class WeeklyRepetitionPatternResponse extends AuditResponseObject implements IWeeklyRepetitionPatternResponse {
    monday!: boolean;
    tuesday!: boolean;
    wednesday!: boolean;
    thursday!: boolean;
    friday!: boolean;
    saturday!: boolean;
    sunday!: boolean;

    constructor(data?: IWeeklyRepetitionPatternResponse) {
        super(data);
        this._discriminator = "WeeklyRepetitionPatternResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.monday = _data["monday"] !== undefined ? _data["monday"] : <any>null;
            this.tuesday = _data["tuesday"] !== undefined ? _data["tuesday"] : <any>null;
            this.wednesday = _data["wednesday"] !== undefined ? _data["wednesday"] : <any>null;
            this.thursday = _data["thursday"] !== undefined ? _data["thursday"] : <any>null;
            this.friday = _data["friday"] !== undefined ? _data["friday"] : <any>null;
            this.saturday = _data["saturday"] !== undefined ? _data["saturday"] : <any>null;
            this.sunday = _data["sunday"] !== undefined ? _data["sunday"] : <any>null;
        }
    }

    static fromJS(data: any): WeeklyRepetitionPatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRepetitionPatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday !== undefined ? this.monday : <any>null;
        data["tuesday"] = this.tuesday !== undefined ? this.tuesday : <any>null;
        data["wednesday"] = this.wednesday !== undefined ? this.wednesday : <any>null;
        data["thursday"] = this.thursday !== undefined ? this.thursday : <any>null;
        data["friday"] = this.friday !== undefined ? this.friday : <any>null;
        data["saturday"] = this.saturday !== undefined ? this.saturday : <any>null;
        data["sunday"] = this.sunday !== undefined ? this.sunday : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IWeeklyRepetitionPatternResponse extends IAuditResponseObject {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
}

export class AuditLogTaskTypeResponse extends AuditResponseObject implements IAuditLogTaskTypeResponse {
    contactRelated!: boolean;
    medicationRelated!: boolean;
    twoPersonTask!: boolean;
    referred!: boolean;

    constructor(data?: IAuditLogTaskTypeResponse) {
        super(data);
        this._discriminator = "AuditLogTaskTypeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactRelated = _data["contactRelated"] !== undefined ? _data["contactRelated"] : <any>null;
            this.medicationRelated = _data["medicationRelated"] !== undefined ? _data["medicationRelated"] : <any>null;
            this.twoPersonTask = _data["twoPersonTask"] !== undefined ? _data["twoPersonTask"] : <any>null;
            this.referred = _data["referred"] !== undefined ? _data["referred"] : <any>null;
        }
    }

    static fromJS(data: any): AuditLogTaskTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogTaskTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactRelated"] = this.contactRelated !== undefined ? this.contactRelated : <any>null;
        data["medicationRelated"] = this.medicationRelated !== undefined ? this.medicationRelated : <any>null;
        data["twoPersonTask"] = this.twoPersonTask !== undefined ? this.twoPersonTask : <any>null;
        data["referred"] = this.referred !== undefined ? this.referred : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogTaskTypeResponse extends IAuditResponseObject {
    contactRelated: boolean;
    medicationRelated: boolean;
    twoPersonTask: boolean;
    referred: boolean;
}

export class AuditLogTaskAssignmentResponse extends AuditResponseObject implements IAuditLogTaskAssignmentResponse {
    type?: AuditLogTaskTypeResponse | null;
    description?: AuditLogDescriptionResponse | null;
    executionInterval?: AuditLogExecutionIntervalResponse | null;
    recurrencePattern?: AuditLogRecurrencePatternResponse | null;
    professions?: AuditLogProfessionResponse | null;

    constructor(data?: IAuditLogTaskAssignmentResponse) {
        super(data);
        this._discriminator = "AuditLogTaskAssignmentResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] ? AuditLogTaskTypeResponse.fromJS(_data["type"]) : <any>null;
            this.description = _data["description"] ? AuditLogDescriptionResponse.fromJS(_data["description"]) : <any>null;
            this.executionInterval = _data["executionInterval"] ? AuditLogExecutionIntervalResponse.fromJS(_data["executionInterval"]) : <any>null;
            this.recurrencePattern = _data["recurrencePattern"] ? AuditLogRecurrencePatternResponse.fromJS(_data["recurrencePattern"]) : <any>null;
            this.professions = _data["professions"] ? AuditLogProfessionResponse.fromJS(_data["professions"]) : <any>null;
        }
    }

    static fromJS(data: any): AuditLogTaskAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogTaskAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>null;
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        data["executionInterval"] = this.executionInterval ? this.executionInterval.toJSON() : <any>null;
        data["recurrencePattern"] = this.recurrencePattern ? this.recurrencePattern.toJSON() : <any>null;
        data["professions"] = this.professions ? this.professions.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogTaskAssignmentResponse extends IAuditResponseObject {
    type?: AuditLogTaskTypeResponse | null;
    description?: AuditLogDescriptionResponse | null;
    executionInterval?: AuditLogExecutionIntervalResponse | null;
    recurrencePattern?: AuditLogRecurrencePatternResponse | null;
    professions?: AuditLogProfessionResponse | null;
}

export class AuditLogAdditionalRepetitionIntervalsResponse extends AuditResponseObject implements IAuditLogAdditionalRepetitionIntervalsResponse {
    additionalRepetitionIntervals!: TaskEntryAdditionalRepetitionIntervalResponse[];

    constructor(data?: IAuditLogAdditionalRepetitionIntervalsResponse) {
        super(data);
        if (!data) {
            this.additionalRepetitionIntervals = [];
        }
        this._discriminator = "AuditLogAdditionalRepetitionIntervalsResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["additionalRepetitionIntervals"])) {
                this.additionalRepetitionIntervals = [] as any;
                for (let item of _data["additionalRepetitionIntervals"])
                    this.additionalRepetitionIntervals!.push(TaskEntryAdditionalRepetitionIntervalResponse.fromJS(item));
            }
            else {
                this.additionalRepetitionIntervals = <any>null;
            }
        }
    }

    static fromJS(data: any): AuditLogAdditionalRepetitionIntervalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogAdditionalRepetitionIntervalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalRepetitionIntervals)) {
            data["additionalRepetitionIntervals"] = [];
            for (let item of this.additionalRepetitionIntervals)
                data["additionalRepetitionIntervals"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogAdditionalRepetitionIntervalsResponse extends IAuditResponseObject {
    additionalRepetitionIntervals: TaskEntryAdditionalRepetitionIntervalResponse[];
}

export class TaskEntryAdditionalRepetitionIntervalResponse implements ITaskEntryAdditionalRepetitionIntervalResponse {
    id!: string;
    start!: string;
    end!: string;

    constructor(data?: ITaskEntryAdditionalRepetitionIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.end = _data["end"] !== undefined ? _data["end"] : <any>null;
        }
    }

    static fromJS(data: any): TaskEntryAdditionalRepetitionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEntryAdditionalRepetitionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["end"] = this.end !== undefined ? this.end : <any>null;
        return data; 
    }
}

export interface ITaskEntryAdditionalRepetitionIntervalResponse {
    id: string;
    start: string;
    end: string;
}

export class CreatedAssignmentInstructionsResponse implements ICreatedAssignmentInstructionsResponse {
    instructionIds!: string[];

    constructor(data?: ICreatedAssignmentInstructionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructionIds"])) {
                this.instructionIds = [] as any;
                for (let item of _data["instructionIds"])
                    this.instructionIds!.push(item);
            }
            else {
                this.instructionIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CreatedAssignmentInstructionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedAssignmentInstructionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructionIds)) {
            data["instructionIds"] = [];
            for (let item of this.instructionIds)
                data["instructionIds"].push(item);
        }
        return data; 
    }
}

export interface ICreatedAssignmentInstructionsResponse {
    instructionIds: string[];
}

export class AddAssignmentInstructionsRequest implements IAddAssignmentInstructionsRequest {
    instructions!: InstructionRequest[];
    actionId!: string;
    isMoved!: boolean;

    constructor(data?: IAddAssignmentInstructionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionRequest.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
            this.isMoved = _data["isMoved"] !== undefined ? _data["isMoved"] : <any>null;
        }
    }

    static fromJS(data: any): AddAssignmentInstructionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssignmentInstructionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        data["isMoved"] = this.isMoved !== undefined ? this.isMoved : <any>null;
        return data; 
    }
}

export interface IAddAssignmentInstructionsRequest {
    instructions: InstructionRequest[];
    actionId: string;
    isMoved: boolean;
}

export class InstructionRequest implements IInstructionRequest {
    id!: string;
    order!: number;

    constructor(data?: IInstructionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): InstructionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data; 
    }
}

export interface IInstructionRequest {
    id: string;
    order: number;
}

export class AssignmentInstructionResponse implements IAssignmentInstructionResponse {
    instructionId!: string;
    order!: number;

    constructor(data?: IAssignmentInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instructionId = _data["instructionId"] !== undefined ? _data["instructionId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentInstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentInstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructionId"] = this.instructionId !== undefined ? this.instructionId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data; 
    }
}

export interface IAssignmentInstructionResponse {
    instructionId: string;
    order: number;
}

export class AddAssignmentFormsRequest implements IAddAssignmentFormsRequest {
    forms!: FormRequest[];
    actionId!: string;
    isMoved!: boolean;

    constructor(data?: IAddAssignmentFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormRequest.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
            this.isMoved = _data["isMoved"] !== undefined ? _data["isMoved"] : <any>null;
        }
    }

    static fromJS(data: any): AddAssignmentFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssignmentFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        data["isMoved"] = this.isMoved !== undefined ? this.isMoved : <any>null;
        return data; 
    }
}

export interface IAddAssignmentFormsRequest {
    forms: FormRequest[];
    actionId: string;
    isMoved: boolean;
}

export class FormRequest implements IFormRequest {
    formId!: string;
    required!: boolean;
    order!: number;
    paused!: boolean;

    constructor(data?: IFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
        }
    }

    static fromJS(data: any): FormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        return data; 
    }
}

export interface IFormRequest {
    formId: string;
    required: boolean;
    order: number;
    paused: boolean;
}

export class AssignmentFormResponse implements IAssignmentFormResponse {
    formId!: string;
    required!: boolean;
    order!: number;
    paused!: boolean;

    constructor(data?: IAssignmentFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        return data; 
    }
}

export interface IAssignmentFormResponse {
    formId: string;
    required: boolean;
    order: number;
    paused: boolean;
}

export class AssignmentsQueryResponse implements IAssignmentsQueryResponse {
    assignmentId!: string;
    instanceId!: string;
    instructions!: AssignmentInstructionResponse[];
    forms!: AssignmentFormQueryResponse[];

    constructor(data?: IAssignmentsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructions = [];
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : <any>null;
            this.instanceId = _data["instanceId"] !== undefined ? _data["instanceId"] : <any>null;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AssignmentInstructionResponse.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(AssignmentFormQueryResponse.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignmentsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : <any>null;
        data["instanceId"] = this.instanceId !== undefined ? this.instanceId : <any>null;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAssignmentsQueryResponse {
    assignmentId: string;
    instanceId: string;
    instructions: AssignmentInstructionResponse[];
    forms: AssignmentFormQueryResponse[];
}

export class AssignmentFormQueryResponse implements IAssignmentFormQueryResponse {
    residentId!: string;
    assignmentId!: string;
    order!: number;
    formId!: string;
    required!: boolean;
    registrationId?: string | null;

    constructor(data?: IAssignmentFormQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentFormQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentFormQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        return data; 
    }
}

export interface IAssignmentFormQueryResponse {
    residentId: string;
    assignmentId: string;
    order: number;
    formId: string;
    required: boolean;
    registrationId?: string | null;
}

export class AssignmentsQueryRequest implements IAssignmentsQueryRequest {
    assignmentQueryRequestItems!: AssignmentQueryRequestItem[];

    constructor(data?: IAssignmentsQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignmentQueryRequestItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignmentQueryRequestItems"])) {
                this.assignmentQueryRequestItems = [] as any;
                for (let item of _data["assignmentQueryRequestItems"])
                    this.assignmentQueryRequestItems!.push(AssignmentQueryRequestItem.fromJS(item));
            }
            else {
                this.assignmentQueryRequestItems = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignmentsQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentsQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignmentQueryRequestItems)) {
            data["assignmentQueryRequestItems"] = [];
            for (let item of this.assignmentQueryRequestItems)
                data["assignmentQueryRequestItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAssignmentsQueryRequest {
    assignmentQueryRequestItems: AssignmentQueryRequestItem[];
}

export class AssignmentQueryRequestItem implements IAssignmentQueryRequestItem {
    residentId!: string;
    assignmentId!: string;
    instanceId!: string;

    constructor(data?: IAssignmentQueryRequestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : <any>null;
            this.instanceId = _data["instanceId"] !== undefined ? _data["instanceId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentQueryRequestItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentQueryRequestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : <any>null;
        data["instanceId"] = this.instanceId !== undefined ? this.instanceId : <any>null;
        return data; 
    }
}

export interface IAssignmentQueryRequestItem {
    residentId: string;
    assignmentId: string;
    instanceId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}